// @flow
import * as React from 'react';
import { mapProps } from 'recompose';
import type { HOC as ElementType } from 'recompose';
import styled, { css } from 'styled-components';
import { Image } from './../../Image/Image';

const staticPath = '/cdn';
export const Icon = mapProps(({ uri, type = 'icons', ...props }) => ({
  src: `${staticPath}/${type}/${uri}`,
  ...props,
}))(Image);

const HoverWrapper = styled.div`
  display: inline-block;
  position: relative;
  &:after {
    background-color: var(--color-grey-1);
    border-radius: 50%;
    content: '';
    display: block;
    ${({ hoverSize }) => css`
      height: ${hoverSize};
      width: ${hoverSize};
    `};
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 34px;
    transition: opacity 300ms ease-out;
    z-index: -1;
  }
  &:hover,
  &:focus {
    &:after {
      opacity: 1;
    }
  }
`;

type hoverProps = {
  hoverSize?: string,
};

export const withHover = (Comp: ElementType) => ({
  hoverSize = '34px',
  ...props
}: hoverProps) => (
  <HoverWrapper hoverSize={hoverSize}>
    <Comp {...props} />
  </HoverWrapper>
);
